<div class="tab-content">
  <div class="main-content">
    <div class="main-heading">
      <strong>
        <span translate>MOVE_BUSINESS</span>
      </strong>
    </div>
    <div class="card">
      <div class="card-body">
        <form [formGroup]="moveBusinessForm">
          <div class="row">
            <div class="col-md-6 pb-4">
              <div class="form-group">
                <label>
                  <span translate>FROM</span>
                  <span class="required">*</span>
                </label>
                <div>
                  <p-dropdown
                    #frm
                    formControlName="fromUser"
                    [required]="true"
                    [options]="Users"
                    [filter]="true"
                    optionLabel="label"
                    optionValue="value"
                    [style]="{ width: '100%' }"
                    (onChange)="onFromUserChange($event)"
                    placeholder="{{ 'Select' | translate }}"
                  ></p-dropdown>
                </div>
              </div>
              <div *ngIf="isFromUserSelected">
                <label>
                  <span translate>CHOOSE_BUSINESS</span>
                  <span class="required">*</span>
                </label>
                <div class="table-view">
                  <p-table
                    #dtBusiness
                    [value]="businesslist"
                    dataKey="Id"
                    [(selection)]="selectedBusiness"
                    [scrollable]="true"
                    scrollHeight="600px"
                  >
                    <ng-template pTemplate="header">
                      <tr>
                        <th style="width: 35px">
                          <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
                        </th>
                        <th>{{ "COMPANY" | translate }}</th>
                      </tr>
                      <tr>
                        <th></th>
                        <th>
                          <input
                            pInputText
                            type="text"
                            (input)="
                              dtBusiness.filter(
                                $any($event.target)?.value,
                                'CompanyName',
                                'contains'
                              )
                            "
                            placeholder="{{ 'Search' | translate }}"
                            class="p-column-filter"
                          />
                        </th>
                      </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-business>
                      <tr>
                        <td style="width: 35px">
                          <p-tableCheckbox [value]="business">
                          </p-tableCheckbox>
                        </td>
                        <td>
                          <span>{{ business.CompanyName }}</span>
                        </td>
                      </tr>
                    </ng-template>
                    <ng-template pTemplate="emptymessage">
                      <tr>
                        <td colspan="2">
                          {{ "NO_RECORDS_FOUND" | translate }}
                        </td>
                      </tr>
                    </ng-template>
                  </p-table>
                </div>
              </div>
            </div>

            <div class="col-md-6">
              <div class="form-group">
                <label>
                  <span translate>TO</span>
                  <span class="required">*</span>
                </label>
                <div>
                  <p-dropdown
                    #to
                    formControlName="toUser"
                    [required]="true"
                    [options]="SelectedUser"
                    [filter]="true"
                    optionLabel="label"
                    optionValue="value"
                    [style]="{ width: '100%' }"
                    (onChange)="onToUserChange($event)"
                    placeholder="{{ 'Select' | translate }}"
                  ></p-dropdown>
                </div>
              </div>
              <div *ngIf="tblUser && tblUser.length > 0">
                <label>
                  <span translate>Assign access</span>
                </label>
                <div class="table-view">
                  <p-table
                    #dtUsers
                    [value]="tblUser"
                    dataKey="Id"
                    [scrollable]="true"
                    scrollHeight="600px"
                  >
                    <ng-template pTemplate="header">
                      <tr>
                        <th style="width: 35px">
                          <p-checkbox
                            [binary]="true"
                            (onChange)="checkAll($event.checked)"
                            [ngModel]="isAllUsersChecked"
                            [ngModelOptions]="{ standalone: true }"
                            [disabled]="!canCheckAll"
                          >
                          </p-checkbox>
                        </th>
                        <th>{{ "Name" | translate }}</th>
                      </tr>
                      <tr>
                        <th></th>
                        <th>
                          <input
                            pInputText
                            type="text"
                            (input)="
                              dtUsers.filter(
                                $any($event.target)?.value,
                                'Name',
                                'contains'
                              )
                            "
                            placeholder="{{ 'Search' | translate }}"
                            class="p-column-filter"
                          />
                        </th>
                      </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-user>
                      <tr>
                        <td style="width: 35px">
                          <p-checkbox
                            [(ngModel)]="user.IsChecked"
                            [ngModelOptions]="{ standalone: true }"
                            [disabled]="user.IsPortalManager"
                            [binary]="true"
                            (onChange)="userChecked(user)"
                          >
                          </p-checkbox>
                        </td>
                        <td>
                          <span>{{ user.Name }}</span>
                          <span *ngIf="user.IsPortalManager"> (Manager)</span>
                        </td>
                      </tr>
                    </ng-template>
                    <ng-template pTemplate="emptymessage">
                      <tr>
                        <td colspan="2">
                          {{ "NO_RECORDS_FOUND" | translate }}
                        </td>
                      </tr>
                    </ng-template>
                  </p-table>
                </div>
              </div>
            </div>
          </div>
        </form>
        <div class="action-btns-wrapper">
          <button
            type="button"
            class="btn btn-primary"
            (click)="moveBusiness()"
            [disabled]="
              loading ||
              moveBusinessForm.invalid ||
              !selectedBusiness ||
              selectedBusiness.length === 0
            "
          >
            <span *ngIf="!loading" translate>MOVE</span>
            <span *ngIf="loading">Moving...</span>
            <span class="icon ic-xs icon-forward"></span>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
<toaster-component></toaster-component>
<div class="panel-loader" *ngIf="loading"></div>
